<h1 mat-dialog-title>{{ 'NEW_COMPANY_DIALOG.NEW' | translate }} {{ companyDefaultType.value | titlecase }}</h1>

<mat-dialog-content>
  <div>
    <mat-button-toggle-group [formControl]="companyDefaultType">
      <mat-button-toggle [value]="CompanyType.seller" [disabled]="!allowSellerCreate">
        <span>Seller</span>
      </mat-button-toggle>
      <mat-button-toggle [value]="CompanyType.debtor" [disabled]="!allowDebtorCreate">
        <span>Debtor</span>
      </mat-button-toggle>
    </mat-button-toggle-group>

    <!--Company-->
    <form fxLayout="column" fxLayoutGap="10px" [formGroup]="companyFormGroup" style="margin-top: 1em">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-form-field appearance="fill" fxFlex>
          <mat-label>{{ 'NEW_COMPANY_DIALOG.COMPANY.BUSINESS_NAME' | translate }}</mat-label>
          <input matInput formControlName="businessName">
          <mat-error *ngIf="checkError(sellerBusinessName)">
            <ng-container *ngIf="sellerBusinessName.hasError('required')">
              <span>{{ 'NEW_COMPANY_DIALOG.ERROR.REQUIRED' | translate }}</span>
            </ng-container>
          </mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <mat-form-field appearance="fill" fxFlex="50">
          <mat-label>{{ 'NEW_COMPANY_DIALOG.COMPANY.TAX_CODE_PREFIX' | translate }}</mat-label>
          <mat-select formControlName="taxCodePrefix">
            <mat-option *ngFor="let code of taxCodeData.taxCode" [value]="code.value">
              <span>{{ code.country }} - {{ code.value }}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="label-align" appearance="fill" fxFlex="50">
          <mat-label>{{ 'NEW_COMPANY_DIALOG.COMPANY.TAX_CODE' | translate }}</mat-label>
          <span matPrefix>{{ companyFormGroup.get('taxCodePrefix').value }} &nbsp;</span>
          <input matInput formControlName="taxCode">
          <mat-error *ngIf="checkError(companyFormGroup.get('taxCode'))">
            <ng-container *ngIf="companyFormGroup.get('taxCode').hasError('required')">
              <span>{{ 'NEW_COMPANY_DIALOG.ERROR.REQUIRED' | translate }}</span>
            </ng-container>
            <ng-container *ngIf="companyFormGroup.get('taxCode').hasError('length')">
              <span>{{ 'NEW_COMPANY_DIALOG.ERROR.WRONG_FORMAT' | translate }}</span>
            </ng-container>
            <ng-container *ngIf="companyFormGroup.get('taxCode').hasError('pattern')">
              <span>{{ 'NEW_COMPANY_DIALOG.ERROR.WRONG_FORMAT' | translate }}</span>
            </ng-container>
            <ng-container *ngIf="companyFormGroup.get('taxCode').hasError('checksum')">
              <span>{{ 'NEW_COMPANY_DIALOG.ERROR.WRONG_FORMAT' | translate }}</span>
            </ng-container>
          </mat-error>
          <mat-error>
            <ng-container
              *ngIf="companyFormGroup.get('taxCode').hasError('forbidden')">{{ 'NEW_COMPANY_DIALOG.ERROR.TAX_CODE_ALREADY_USED' | translate }}
            </ng-container>
          </mat-error>
        </mat-form-field>
      </div>
    </form>

    <ng-container *ngIf="companyDefaultType.value === CompanyType.seller">
      <form fxLayout="column" fxLayoutGap="10px" [formGroup]="sellerContactFormGroup">
        <h3>{{ 'NEW_COMPANY_DIALOG.CONTACT_DATA' | translate }}</h3>
        <div fxLayout="row" fxLayoutGap="10px">
          <mat-form-field appearance="fill" fxFlex="50">
            <mat-label>{{ 'NEW_COMPANY_DIALOG.COMPANY.LAST_NAME' | translate }}</mat-label>
            <input matInput formControlName="contactLastName">
            <mat-error *ngIf="checkError(sellerContactLastName)">
              <span
                *ngIf="sellerContactLastName.hasError('required')">{{ 'NEW_COMPANY_DIALOG.ERROR.REQUIRED' | translate }}</span>
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="fill" fxFlex="50">
            <mat-label>{{ 'NEW_COMPANY_DIALOG.COMPANY.FIRST_NAME' | translate }}</mat-label>
            <input matInput formControlName="contactFirstName">
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutGap="10px">
          <mat-form-field appearance="fill" fxFlex="50">
            <mat-label>{{ 'NEW_COMPANY_DIALOG.COMPANY.PHONE' | translate }}</mat-label>
            <input matInput formControlName="contactPhone">
          </mat-form-field>
          <mat-form-field appearance="fill" fxFlex="50">
            <mat-label>{{ 'NEW_COMPANY_DIALOG.COMPANY.EMAIL' | translate }}</mat-label>
            <input matInput formControlName="contactEmail">
            <mat-error *ngIf="checkError(sellerContactEmail)">
              <span
                *ngIf="sellerContactEmail.hasError('required')">{{ 'NEW_COMPANY_DIALOG.ERROR.REQUIRED' | translate }}</span>
            </mat-error>
            <mat-error *ngIf="sellerContactEmail.invalid">
              <span
                *ngIf="sellerContactEmail.hasError('email')">{{ 'NEW_COMPANY_DIALOG.ERROR.INVALID_EMAIL' | translate }}</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="row">
          <mat-form-field appearance="fill" fxFlex>
            <mat-label>{{ 'NEW_COMPANY_DIALOG.COMPANY.NOTE' | translate }}</mat-label>
            <input matInput formControlName="notes">
          </mat-form-field>
        </div>
      </form>
    </ng-container>

    <!-- Address -->
    <form [formGroup]="addressFormGroup">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <h3>{{ 'NEW_COMPANY_DIALOG.ADDRESS.TITLE' | translate }}</h3>
        <button mat-icon-button (click)="showAddress = !showAddress">
          <ng-container *ngIf="showAddress; else down">
            <mat-icon>keyboard_arrow_up</mat-icon>
          </ng-container>
          <ng-template #down>
            <mat-icon>keyboard_arrow_down</mat-icon>
          </ng-template>
        </button>
      </div>
      <div [@addressExpand]="showAddress ? 'expanded' : 'collapsed'"
           fxLayout="column"
           fxLayoutGap="10px"
           style="overflow: hidden">
        <div fxLayout="row">
          <mat-form-field appearance="fill" fxFlex>
            <mat-label>{{ 'NEW_COMPANY_DIALOG.ADDRESS.ADDRESS_1' | translate }}</mat-label>
            <input matInput formControlName="address1">
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutGap="10px">
          <mat-form-field appearance="fill" fxFlex="33">
            <mat-label>{{ 'NEW_COMPANY_DIALOG.ADDRESS.CITY' | translate }}</mat-label>
            <input matInput formControlName="city">
          </mat-form-field>
          <mat-form-field appearance="fill" fxFlex="33">
            <mat-label>{{ 'NEW_COMPANY_DIALOG.ADDRESS.STATE' | translate }}</mat-label>
            <input matInput #state formControlName="state" maxlength="2">
            <mat-hint align="end">{{ state.value.length }} / 2</mat-hint>
          </mat-form-field>
          <mat-form-field appearance="fill" fxFlex="33">
            <mat-label>{{ 'NEW_COMPANY_DIALOG.ADDRESS.ZIP' | translate }}</mat-label>
            <input matInput #zip formControlName="zip" maxlength="5">
            <mat-hint align="end">{{ zip.value.length }} / 5</mat-hint>
          </mat-form-field>
        </div>
        <div fxLayout="row">
          <mat-form-field appearance="fill" fxFlex>
            <mat-label>{{ 'NEW_COMPANY_DIALOG.ADDRESS.COUNTRY' | translate }}</mat-label>
            <input matInput formControlName="country">
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutGap="10px">
          <mat-form-field appearance="fill" fxFlex="50">
            <mat-label>{{ 'NEW_COMPANY_DIALOG.ADDRESS.PHONE' | translate }}</mat-label>
            <input matInput formControlName="companyPhone">
          </mat-form-field>
          <mat-form-field appearance="fill" fxFlex="50">
            <mat-label>{{ 'NEW_COMPANY_DIALOG.ADDRESS.FAX' | translate }}</mat-label>
            <input matInput formControlName="companyFax">
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button
          [mat-dialog-close]="undefined"
          class="btn-margin"
          [disabled]="isSaving">
    <span>{{ 'NEW_COMPANY_DIALOG.CANCEL' | translate }}</span>
  </button>

  <button mat-flat-button
          [disabled]="checkDisabled()"
          (click)="onSubmit()"
          color="accent"
          class="btn-margin"
          fxLayout="row"
          fxLayoutAlign="center center"
          style="height: 36px; width: 100px">
    <ng-container *ngIf="!isSaving; else saving">
      <span>{{ 'NEW_COMPANY_DIALOG.SAVE' | translate }}</span>
    </ng-container>
    <ng-template #saving>
      <mat-progress-spinner
        mode="indeterminate"
        color="primary"
        [diameter]="18">
      </mat-progress-spinner>
    </ng-template>
  </button>
</mat-dialog-actions>
